module.exports = __webpack_public_path__ + "img/antes_despues_283.48f18299.png";